import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BackendService } from '../../../core/backend.service';
import { IsoHierarchyQueryBaseService } from '../../../shared/equipment-functions/iso-hierarchy-query-base.service';
import { RunnableModelSearchResult } from '../../../viewmodels/equipment/equipment-function-model-search-result';
import { EquipmentFunctionModelSelectionCriteriaBase } from '../../../viewmodels/equipment/equipment-function-model-selection-criteria-base';
import { RunnableEquipmentFunctionModelSelectionCriteria } from '../../../viewmodels/equipment/runnable-equipment-function-model-selection-criteria';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceStrategyFailureDataService extends IsoHierarchyQueryBaseService {
  modelSelected = new Subject<RunnableModelSearchResult>();

  constructor(private backendService: BackendService) {
    super();
  }

  selectData(criteria: RunnableEquipmentFunctionModelSelectionCriteria) {
    this.modelSelected.next(criteria.searchResult);
  }

  createCriteria(): EquipmentFunctionModelSelectionCriteriaBase {
    const criteria = new RunnableEquipmentFunctionModelSelectionCriteria();
    criteria.requiresFunctions = false;
    criteria.excludedModelIds = this.excludedDataIds;

    return criteria;
  }

  findData(criteria: RunnableEquipmentFunctionModelSelectionCriteria): Observable<RunnableEquipmentFunctionModelSelectionCriteria> {
    criteria.searchResult = null;
    return this.backendService.create(RunnableEquipmentFunctionModelSelectionCriteria, criteria, false);
  }
}
